import { INode } from 'shared/types/tree'
import { getTree } from 'shared/hooks'
import { createIdMap, NodeIdMap } from '../version_mapping/utility'
import { normalizeNodes } from 'shared/utils/tree'

export async function fetchTreesAndIdMaps(...treeIds: string[]) {
  const trees = await fetchTrees(treeIds)
  const idMaps = trees.reduce<{ [key: string]: NodeIdMap }>((acc, tree) => {
    // Recursively ensure nodes property is an array
    normalizeNodes(tree)

    acc[`${tree.tree_id}:${tree.version}`] = createIdMap(tree)
    return acc
  }, {})
  return { trees, idMaps }
}

async function fetchTrees(treeIds: string[]) {
  return await treeIds.reduce<Promise<INode[]>>(async (acc, ids) => {
    const trees = await acc
    const [treeId, versionId] = ids.split(':')
    if (!treeId || !versionId) return trees
    const { result: tree } = await getTree({ treeId, versionId })
    tree && trees.push(tree)
    return trees
  }, Promise.resolve([]))
}

export function nodeForItem(
  item: { treeId: string; version: string; id: string },
  idMaps: { [k: string]: NodeIdMap },
) {
  const idMap = idMaps[`${item.treeId}:${item.version}`]
  const { node } = idMap[item.id]
  return node
}
